const BaseInput: React.FC<{
  className?: string;
  id: string;
  value?: string | number;
  checked?: boolean;
  type?: string;
  onChange: (e: any) => void;
  required?: boolean;
}> = ({ className, id, type, value, checked, onChange, required }) => {
  return (
    <input
      checked={checked}
      className={`control ${className ? className : ""}`}
      id={id}
      type={type || "text"}
      value={value || ""}
      onChange={onChange}
      required={required || false}
    />
  );
};

export default BaseInput;
